$('.js-trigger-click').on('click', function(event) {
  event.preventDefault();

  const $element = $($(this).attr('href'));

  if (!$element.length) {
    return;
  }

  $element.trigger('click');
});



// WEBPACK FOOTER //
// ./../src/assets/js/trigger-events.js